import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaDecisiones from './TablaDecisiones';

const Decisiones: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaDecisiones />
  </Box>
);

export default Decisiones;
